import {CSSTransition} from "react-transition-group";
//import {isEmpty} from "lodash-es";
import {isEmpty} from "lodash";
import React from "react";


const FieldError = ({errors})=>{
  return (
    <CSSTransition
      in={!isEmpty(errors)}
      timeout={300}
      classNames="error"
      unmountOnExit
    >
      <span className="form-input-error__message u__block">
        {errors && errors[0]}
      </span>
    </CSSTransition>
  );
};

export default FieldError;
